<script setup lang="ts">
import { onMounted } from 'vue';
import { ToastNotification } from '@/features/ToastNotification';
import { useRtl } from '@/shared/composables';

const { isRtl } = useRtl();

onMounted(() => {
  if (isRtl.value) {
    document.body.classList.add('rtl');
  }
});
</script>

<template>
  <RouterView />
  <ToastNotification />
</template>
